@if (mfaResolveSession$ | async; as mfaResolveSession) {
  <p>Please enter the code provided by your authenticator app</p>
  <br/>
  <tp-form [formGroup]="mfaForm" [isSubmitting$]="isSubmitting$" (doSubmit)="mfaReauth(mfaResolveSession)">
    <div class="login-form-input-actions-row">
      <tp-form-input type="text" [form]="mfaForm" field="mfaCode" label="MFA Code" />
      <tp-form-actions [height]="44" [submitDisabled]="!mfaForm.dirty" submitText="Submit" [isSubmitting]="isSubmitting$ | async" buttonIdPrefix="mfaSignIn"/>
    </div>
  </tp-form>
  <br/>
  <p class="lost-mfa-method">Lost your MFA method? <a href="mailto:support@typedb.com">Contact us <i class="fa-light fa-arrow-up-right-from-square"></i></a></p>
} @else {
  <p>For security reasons, you must reauthenticate before you can {{ reauthAction }}.</p>

  <div class="tp-sso-buttons">
    <button (click)="googleReauth()" id="googleSignIn"><img src="/assets/logo/google.svg" alt=""/>Google</button>
    <button (click)="microsoftReauth()" id="microsoftSignIn"><img src="/assets/logo/microsoft.svg" alt=""/>Microsoft</button>
    <button (click)="githubReauth()" id="githubSignIn"><img src="/assets/logo/github.svg" alt=""/>GitHub</button>
  </div>

  <div class="tp-login-method-separator">
    <hr/> or <hr/>
  </div>

  <tp-form [formGroup]="reauthForm" [isSubmitting$]="isSubmitting$" (doSubmit)="submitReauth()">
    <tp-form-input readonly [form]="reauthForm" field="email" label="Email"></tp-form-input>
    <div class="login-form-input-actions-row">
      <tp-form-password-input autocomplete="current-password" [form]="reauthForm" label="Password" field="password"/>
      <tp-form-actions [height]="44" [isSubmitting]="isSubmitting$ | async" submitText="Submit" buttonIdPrefix="signIn" [submitDisabled]="!reauthForm.dirty"/>
    </div>
  </tp-form>
}
